module.exports = __webpack_public_path__ + "img/profile-picture.ccffe047.jpg";